export default __webpack_public_path__ + "static/media/overcome-corporate-challenges.585103da.svg";